import React from 'react';
import { Box, CallToActionButton, Container, FlexBox, IconFontAwesome } from '@directsoftware/ui-kit-web-admin';
import { useSelector } from 'react-redux';
import ListingsSearchDateRange from '../atoms/listings-search-date-range';
import { useDetectMobile } from '../../../../shared/hooks/useDetectMobile';
import ListingsSearchSort from '../atoms/listings-search-sort';
import ListingsSearchFilterAmenities from '../atoms/listings-search-filter-amenities';
import ListingsSearchFilterFeatures from '../atoms/listings-search-filter-features';
import { selectListingsSearchState } from '../../../redux/slices/listingsSearch';

const ListingsSearchFilterBar = ({ updateSearchState, translate }) => {
  const { isMobile } = useDetectMobile();
  const searchState = useSelector(selectListingsSearchState);
  const brand = useSelector(state => state.brand);
  const defaultSort = brand.organization_id === 52 ? 'name' : 'default';

  const hasActiveSearch =
    Boolean(searchState.checkIn || searchState.checkOut) ||
    (Array.isArray(searchState.selectedAmenities) &&
      searchState.selectedAmenities.length > 0) ||
    Boolean(searchState.filter_instantBook) ||
    (searchState.filter_numBedrooms || 0) > 0 ||
    (searchState.filter_numBathrooms || 1) > 1 ||
    (searchState.guests || 1) > 1 ||
    searchState.filter_priceLow != null ||
    searchState.filter_priceHigh != null ||
    (searchState.filter_distance || 0) > 0 ||
    Boolean(searchState.loc) ||
    Boolean(searchState.sort && searchState.sort !== defaultSort) ||
    Boolean(searchState.eventSearch);

  const clearAllFilters = () => {
    updateSearchState(
      {
        checkIn: null,
        checkOut: null,
        bookingRange: null,
        guests: 1,
        loc: null,
        geoNELat: null,
        geoNELon: null,
        geoSWLat: null,
        geoSWLon: null,
        sort: defaultSort,
        filter_numBedrooms: 0,
        filter_numBathrooms: 1,
        filter_instantBook: false,
        instantBookingOnly: false,
        filter_priceLow: null,
        filter_priceHigh: null,
        filter_distance: 0,
        amenities: [],
        selectedAmenities: [],
        eventSearch: null,
        currentPage: 0,
        pageOffset: 0
      },
      true
    );
  };

  return (
    <Box>
      <Container variation="fluid-wls">
        <FlexBox alignItems="center" className="filter-bar" gap="xs">
          <ListingsSearchDateRange
            updateSearchState={updateSearchState}
            translate={translate}
          />
          <ListingsSearchFilterFeatures
            updateSearchState={updateSearchState}
            translate={translate}
          />
          <ListingsSearchFilterAmenities
            updateSearchState={updateSearchState}
          />
          {!isMobile && (
            <ListingsSearchSort
              translate={translate}
              updateSearchState={updateSearchState}
            />
          )}
          {hasActiveSearch && (
            <CallToActionButton
              onClick={clearAllFilters}
              variation="secondary"
              appearance="ghost"
              size="dense"
              title="Clear all"
              prependIcon={<IconFontAwesome name="times" iconStyle="regular" />}
            >
              {isMobile ? null : 'Clear all'}
            </CallToActionButton>
          )}
        </FlexBox>
      </Container>
    </Box>
  );
};

export default ListingsSearchFilterBar;
